<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Efectividad de Recaudación</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="exportar" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="tipo_fecha"
                  id="tipo_fecha"
                  v-model="form.tipo_fecha"
                >
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizado</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="desde"
                  v-model="form.desde"
                  locale="es"
                  no-label
                  only-date
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="hasta"
                  v-model="form.hasta"
                  locale="es"
                  no-label
                  only-date
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Hasta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputBodega"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="bodegas"
                  id="bodegas"
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="recaudaciones.length > 0" class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div style="max-height: 300px" class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Recaudador</th>
                    <th v-for="(dia, index) in dias" :key="index">
                      {{ dia }}
                    </th>
                    <th>Total</th>
                    <th>Activas</th>
                    <th>Supervisión</th>
                    <th>Devueltas</th>
                    <th>Total Activas</th>
                    <th>Cobradas</th>
                    <th>No Cobradas</th>
                    <th>Efectividad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="recaudador.nombre_recaudador"
                    v-for="recaudador in recaudaciones"
                  >
                    <td>
                      {{ recaudador.nombre_recaudador }}
                    </td>
                    <td v-for="(dia, index) in dias" :key="index">
                      {{
                        recaudador[dia] != null
                          ? moneyFormat(recaudador[dia])
                          : moneyFormat(0)
                      }}
                    </td>
                    <td>
                      <strong>{{ moneyFormat(recaudador.total) }}</strong>
                    </td>
                    <td>
                      {{ recaudador.activas }}
                    </td>
                    <td>
                      {{ recaudador.supervision }}
                    </td>
                    <td>
                      {{ recaudador.devueltas }}
                    </td>
                    <td>
                      {{ recaudador.total_activas }}
                    </td>
                    <td>
                      {{ recaudador.cobradas }}
                    </td>
                    <td>
                      {{ recaudador.no_cobradas }}
                    </td>
                    <td>
                      <strong>{{ recaudador.efectividad }}</strong>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="row">Total</th>
                    <td v-for="(dia, index) in dias" :key="index">
                      <strong>{{ moneyFormat(obtenerTotalDia(dia)) }}</strong>
                    </td>
                    <td>
                      <strong>{{ moneyFormat(totalRecaudado) }}</strong>
                    </td>
                    <td>
                      <strong>{{ activas }}</strong>
                    </td>
                    <td>
                      <strong>{{ supervision }}</strong>
                    </td>
                    <td>
                      <strong>{{ devueltas }}</strong>
                    </td>
                    <td>
                      <strong>{{ totalActivas }}</strong>
                    </td>
                    <td>
                      <strong>{{ cobradas }}</strong>
                    </td>
                    <td>
                      <strong>{{ noCobradas }}</strong>
                    </td>
                    <td>
                      <strong>{{ efectividad }}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bodegas: {
      required: true,
    },
  },
  data: function () {
    return {
      registros: [],
      recaudadores: [],
      selectedBodega: null,
      form: {
        tipo_fecha: "P",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        bodega_id: "",
        tipo_reporte: "N",
      },
      recaudaciones: [],
      moneyFormat: moneyFormat,
      tarjetas: [],
      dias: []
    };
  },
  methods: {
    obtenerTotalDia: function (dia) {
      let total = 0;
      for (let i = 0; i < this.recaudaciones.length; i++) {
        if (this.recaudaciones[i][dia] != null) {
          total += this.recaudaciones[i][dia];
        }
      }
      return round(total, 2);
    },
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else this.form.bodega_id = "";
    },
    exportar: function () {
      this.form.tipo_reporte = "E";
      let urlApi = `${url}/reporte-efectividad-recaudacion${this.serialize(this.form)}`;
      window.open(urlApi, "_blank");
    },
    consultar: function () {
        if (this.selectedBodega != null) {
            this.form.tipo_reporte = "N";
            let urlApi = `${url}/reporte-efectividad-recaudacion`;
            axios
                .get(urlApi, {
                params: this.form,
                })
                .then(({ data }) => {
                this.registros = data.efectividad;
                this.tarjetas = data.targetas;
                this.dias = data.dias;
                let recaudaciones = [];
                for (let key in this.registros) {
                    for (let i = 0; i < this.registros[key].length; i++) {
                    recaudaciones.push(this.registros[key][i]);
                    }
                }
                recaudaciones = _.groupBy(recaudaciones, function (b) {
                    return b.nombre_recaudador;
                });
                let recaudadores = [];
                for (let key in recaudaciones) {
                    let obj = {
                      nombre_recaudador: key,
                      total: 0,
                      recaudador_id: recaudaciones[key][0].recaudador_id,
                      activas: '',
                      cobradas: '',
                      devueltas: '',
                      efectividad: '',
                      no_cobradas: '',
                      supervision: '',
                      total_activas: ''
                    };
                    let total = 0;
                    for (let i = 0; i < recaudaciones[key].length; i++) {
                    let valor = parseFloat(recaudaciones[key][i].valor_abono);
                    total += valor;
                    obj[recaudaciones[key][i].dia_abono] = valor;
                    }
                    obj.total = total;
                    for (let i = 0; i < this.tarjetas.length; i++) {
                      if (this.tarjetas[i].ruta_id == obj.recaudador_id) {
                        obj.activas = this.tarjetas[i].activas;
                        obj.cobradas = this.tarjetas[i].cobradas;
                        obj.devueltas = this.tarjetas[i].devueltas;
                        obj.efectividad = this.tarjetas[i].efectividad;
                        obj.no_cobradas = this.tarjetas[i].no_cobradas;
                        obj.supervision = this.tarjetas[i].supervision;
                        obj.total_activas = this.tarjetas[i].total_activas;
                        break;
                      }
                    }
                    recaudadores.push(obj);
                }
                this.recaudaciones = recaudadores;
                })
                .catch(() => {
                swal("Error", "Hubo un error, intente nuevamente.", "error");
            });
        }
        else 
            swal('Debe seleccionar una sucursal.', 'Aviso', 'warning');
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
  },
  computed: {
    activas: function () {
      let total = 0;
      for (let i = 0; i < this.tarjetas.length; i++) {
        total+= parseInt(this.tarjetas[i].activas);
      }
      return total;
    },
    supervision: function () {
      let total = 0;
      for (let i = 0; i < this.tarjetas.length; i++) {
        total+= parseInt(this.tarjetas[i].supervision);
      }
      return total;
    },
    devueltas: function () {
      let total = 0;
      for (let i = 0; i < this.tarjetas.length; i++) {
        total+= parseInt(this.tarjetas[i].devueltas);
      }
      return total;
    },
    totalActivas: function () {
      let total = 0;
      for (let i = 0; i < this.tarjetas.length; i++) {
        total+= parseInt(this.tarjetas[i].total_activas);
      }
      return total;
    },
    cobradas: function () {
      let total = 0;
      for (let i = 0; i < this.tarjetas.length; i++) {
        total+= parseInt(this.tarjetas[i].cobradas);
      }
      return total;
    },
    noCobradas: function () {
      let total = 0;
      for (let i = 0; i < this.tarjetas.length; i++) {
        total+= parseInt(this.tarjetas[i].no_cobradas);
      }
      return total;
    },
    efectividad: function () {
      if (this.totalActivas > 0) 
        return round(this.cobradas / this.totalActivas, 2);
      else 
        return 0;
    },
    totalRecaudado: function () {
      let total = 0;
      for (let i = 0; i < this.recaudaciones.length; i++) {
        total += this.recaudaciones[i].total;
      }
      return round(total, 2);
    },
  },
  mounted: function () {
    if (this.bodegas.length > 0) {
        this.selectedBodega = this.bodegas[0];
        this.inputBodega();
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteEfectividadRecaudacion.vue